import { MobileLogoutModule } from './mobile-logout/mobile-logout.module';
import { LoginNseModule } from './login-nse/login-nse.module';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BnNgIdleService } from 'bn-ng-idle';

import { CommonModule, DatePipe } from '@angular/common';

import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ConfirmationDialogService } from './services/confirmation-dialog.service';
import { DisabledRightClickDirective } from './directive/disabled-right-click.directive';
import { ClientFilterPipe } from './filters/client-filter.pipe';
import { GroupByWithSumPipe } from './filters/group-by-with-sum.pipe';
import { SharedModule } from './shared/shared.module';
import { ThankYouFDComponent } from './thank-you-fd/thank-you-fd.component';
import { EarningReportsComponent } from './reports-new/earning-reports/earning-reports.component';
import { InvestmentsummaryreportschedulerComponent } from './investmentsummaryreportscheduler/investmentsummaryreportscheduler.component';
import { BankCoveringLetterComponent } from './ncdpdf/bank-covering-letter/bank-covering-letter.component';
import { TallySheetComponent } from './ncdpdf/tally-sheet/tally-sheet.component';
import { MfCentralComponent } from './mf-central/mf-central.component';
import { NgOtpInputModule } from 'ng-otp-input';
// import { CarouselComponent } from 'ngx-owl-carousel-o';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IiflRedirectionComponent } from './iifl-redirection/iifl-redirection.component';
import { DefaultPageComponent } from './default-page/default-page.component';
import { ComprehensiveSummaryComponent } from './comprehensive-summary/comprehensive-summary.component';
import { NomineePreviewLandingComponent } from './nominee-preview-landing/nominee-preview-landing.component';
import { MobilesessionComponent } from './mobilesession/mobilesession.component';
import { EncrdecrService } from './Auth/encrdecr.service'; 
import { TooltipModule } from 'ng2-tooltip-directive';
import { EmpLoginComponent } from './emp-login/emp-login.component';
import { CpLoginIncredComponent } from './cp-login-incred/cp-login-incred.component';
import { PGResponseComponent } from './pg-response/pg-response.component';
import { AUTHENTICATIONFAILEDComponent } from './authentication-failed/authentication-failed.component';

export function initializeEncryption(encryptionService: EncrdecrService) {
  return () => encryptionService.dswe45refd(); // Wait for key to load
}

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    DisabledRightClickDirective,
    ClientFilterPipe,
    GroupByWithSumPipe,
    ThankYouFDComponent,
    EarningReportsComponent,
    InvestmentsummaryreportschedulerComponent,
    TallySheetComponent,
    BankCoveringLetterComponent,
    MfCentralComponent,
    IiflRedirectionComponent,    
    DefaultPageComponent,
    ComprehensiveSummaryComponent,
    NomineePreviewLandingComponent,
    MobilesessionComponent,
    EmpLoginComponent,
    CpLoginIncredComponent,
    PGResponseComponent,
    AUTHENTICATIONFAILEDComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LoginNseModule,
    MobileLogoutModule,
    SharedModule, 
    FormsModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    CarouselModule,
    TooltipModule
  ],
  providers: [
    ConfirmationDialogService,
    DatePipe,
    BnNgIdleService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeEncryption,
      deps: [EncrdecrService],
      multi: true
    }
  ],

  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
